<template>
  <div>
    <h1>{{titulo}}</h1>

    <p>
      Para o presente termos, todas as palavras ou expressões constantes na lista
      abaixo deverão ser entendidas conforme o respectivo significado:
    </p>

    <p>
      a. INTERNET é uma rede mundial que interliga milhões de computadores e
      dispositivos em todo o mundo, de vários tipos e tamanhos, marcas e modelos;
    </p>

    <p>
      b. SITE é o sítio eletrônico, página ou seu conjunto, acessível através do
      acesso à INTERNET, estes possuem um conjunto de informações audiovisuais
      oferecidos por um terceiro, seja ele pessoa física ou jurídica;
    </p>

    <p>
      c. WIFI é o acesso à rede oferecida por este ESTABELECIMENTO, utilizando tecnologia
      de redes sem fio, baseadas na especificação IEEE 802.11, que define a infraestrutura
      física de acesso à uma rede sem a necessidade de utilização de cabos, responsável
      pela limitação de velocidade, faixa de frequência, método de acesso e conectividade
      à INTERNET;
    </p>

    <p>d. CLIENTE é a pessoa que faz uso da WIFI;</p>

    <p>
      e. ESTABELECIMENTO aqui identificado como
      <span class="estabelecimento">o provedor da WIFI</span>.
    </p>

    <br>

    <p>
      Ao utilizar esta rede WIFI, o CLIENTE expressamente aceita, sem reservas
      ou ressalvas, todas as condições abaixo descritas para utilização deste serviço,
      observando que serviço poderá ser interrompido a qualquer momento sem prévio aviso.
    </p>

    <br>

    <h1>DAS OBRIGAÇÕES</h1>

    <p>
      O CLIENTE deverá dispor e manter o equipamento necessário (ex: computador,
      notebook, celulares ou tablets não se limitando apenas a estes), compatível com
      a tecnologia IEEE 802.11 para ter acesso à INTERNET, bem como deverá promover as
      medidas de segurança necessárias à proteção de seus equipamentos e dados contra
      a atuação indevida e invasões não autorizadas de outros usuários da INTERNET e/ou WIFI.
    </p>

    <br>

    <p>O CLIENTE não poderá utilizar a WIFI para os seguintes propósitos:</p>

    <p>a. Propagar ou manter SITE na INTERNET ou WIFI;</p>

    <p>b. Infringir qualquer lei ou regulamento local, estadual, nacional ou internacional aplicável;</p>

    <p>c. Consumir inutilmente os recursos computacionais de forma intencional;</p>

    <p>d. Interceptar ou tentar interceptar a transmissão de dados através de monitoração da WIFI ou INTERNET;</p>

    <br>

    <p>O CLIENTE obriga-se a não divulgar seu usuário e senha a terceiros.</p>

    <br>

    <p>
      O CLIENTE será o único responsável pelo acesso ao conteúdo da WIFI e da INTERNET,
      não se limitando apenas a estas, o qual assume todos os ônus e responsabilidades decorrentes de seus atos.
    </p>

    <br>

    <p>
      O CLIENTE declara e garante, para todos os fins de direito possuir
      capacidade jurídica para celebrar e utilizar o serviço objeto deste termo
      e que está ciente e de pleno acordo com todas as condições apresentadas.
    </p>

    <br>

    <p>
      O CLIENTE é vedada pelo ESTABELECIMENTO a comercialização de serviço ou
      produtos para pessoas físicas ou jurídicas, bem como a formação de rede local
      sem fio em tal ESTABELECIMENTO utilizando a WIFI.
    </p>

    <br>

    <p>A violação destas obrigações está sujeita às penas previstas em lei.</p>

    <br>

    <p>
      O ESTABELECIMENTO deverá envidar os melhores esforços para assegurar e
      desenvolver a qualidade do serviço objeto deste termo, comprometendo-se,
      ainda, a respeitar a privacidade do CLIENTE, garantindo que não divulgará
      informações relativas à sua utilização e informações cadastrais fornecidas,
      a menos que seja obrigada a fazê-lo mediante ordem judicial ou por lei,
      ressalvadas as hipóteses previstas neste termo.
    </p>

    <br>

    <p>
      O ESTABELECIMENTO não tem obrigação de controlar, e não controla o conteúdo
      e natureza dos conteúdos transmitidos, difundidos ou postos à disposição pelos
      CLIENTES, através da WIFI.
    </p>

    <br>

    <p>
      O ESTABELECIMENTO não se responsabiliza, direta ou indiretamente, por quaisquer
      despesas, danos ou perdas que sejam efetiva ou alegadamente causados por quaisquer
      conteúdos, produtos ou serviços disponíveis em referidos SITES ou recursos externos,
      não garantindo a perfeição, qualidade, veracidade, adequação, utilidade ou segurança do
      conteúdo ou de qualquer serviço oferecido, inclusive, mas não se limitando a, serviços
      envolvendo investimentos, seguros, aplicações, transferências de valores, e demais operações
      financeiras, ou pela utilização ou confiança depositada pelo CLIENTE em tais conteúdos,
      produtos ou serviços.
    </p>

    <br>

    <p>
      O ESTABELECIMENTO não se responsabiliza, por possível indisponibilidade temporária
      ou não do acesso à INTERNET ou outros recursos através da WIFI, mesmo que estes possam
      causar perdas, danos, despesas ou lucros cessantes direta ou indiretamente ao CLIENTE ou terceiros.
    </p>
    <a href="javascript:history.go(-1)"> Voltar</a>
  </div>
</template>

<script>
export default {
  name: "Privacidade",
  data() {
    return {
      titulo: "Termo de Serviços"
    };
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Termo.vue